import { ButtonColor } from './Button';
import { Theme, css } from '@emotion/react';

const getButtonColors = ({ colors }: Theme, color: ButtonColor) => {
  switch (color) {
    case 'primary':
      return css`
        --button-background: ${colors.backgroundPrimary};
        --button-foreground: ${colors.textWhite};
        --button-border: ${colors.borderPrimary};

        --contained-disabled-background: ${colors.backgroundLight};
        --contained-disabled-foreground: ${colors.textWhite};

        --outlined-foreground: ${colors.textPrimary};
        --outlined-disabled-foreground: ${colors.textLighter};
        --outlined-disabled-border: ${colors.borderBase};

        --text-foreground: ${colors.textPrimary};
        --text-disabled-foreground: ${colors.textLighter};
      `;
    case 'secondary':
      return css`
        --button-background: ${colors.backgroundDark};
        --button-foreground: ${colors.textWhite};
        --button-border: ${colors.borderBase};

        --contained-disabled-background: ${colors.backgroundLight};
        --contained-disabled-foreground: ${colors.textWhite};

        --outlined-foreground: ${colors.textBase};
        --outlined-disabled-foreground: ${colors.textLighter};
        --outlined-disabled-border: ${colors.borderBase};

        --text-foreground: ${colors.textBase};
        --text-disabled-foreground: ${colors.textLighter};
      `;
    case 'success':
      return css`
        --button-background: ${colors.backgroundSuccess};
        --button-foreground: ${colors.textWhite};
        --button-border: ${colors.borderSuccess};

        --contained-disabled-background: ${colors.backgroundLight};
        --contained-disabled-foreground: ${colors.textWhite};

        --outlined-foreground: ${colors.textSuccess};
        --outlined-disabled-foreground: ${colors.textLighter};
        --outlined-disabled-border: ${colors.borderBase};

        --text-foreground: ${colors.textSuccess};
        --text-disabled-foreground: ${colors.textLighter};
      `;
    case 'danger':
      return css`
        --button-background: ${colors.backgroundDanger};
        --button-foreground: ${colors.textWhite};
        --button-border: ${colors.borderDanger};

        --contained-disabled-background: ${colors.backgroundLight};
        --contained-disabled-foreground: ${colors.textWhite};

        --outlined-foreground: ${colors.textDanger};
        --outlined-disabled-foreground: ${colors.textLighter};
        --outlined-disabled-border: ${colors.borderBase};

        --text-foreground: ${colors.textDanger};
        --text-disabled-foreground: ${colors.textLighter};
      `;
  }
};

//text-transform added so button text is not capitalized
export const commonStyles = (color: ButtonColor) => (theme: Theme) => css`
  ${getButtonColors(theme, color)};

  text-transform: none;

  :hover,
  :active,
  :focus {
    box-shadow: none;
  }

  @media (hover: none) {
    box-shadow: none;
  }
`;

const containedStyle = css`
  background-color: var(--button-background);
  color: var(--button-foreground);

  &:hover {
    background-color: color-mix(in srgb, var(--button-background), black 35%);
  }

  &:disabled {
    background-color: var(--contained-disabled-background);
    color: var(--contained-disabled-foreground);
  }
`;

const textStyle = css`
  background-color: transparent;
  color: var(--text-foreground);

  &:hover {
    background-color: color-mix(in srgb, var(--button-background), white 85%);
  }

  &:disabled {
    color: var(--text-disabled-foreground);
  }
`;

const outlinedStyle = css`
  color: var(--outlined-foreground);
  border: solid 1px var(--button-border);

  &:hover {
    background-color: color-mix(in srgb, var(--button-background), white 85%);
  }
  &:disabled {
    color: var(--outlined-disabled-foreground);
    border-color: var(--outlined-disabled-border);
  }
`;

export const buttonVariantStyles = {
  contained: containedStyle,
  outlined: outlinedStyle,
  text: textStyle,
};

export const largerText = ({ typography }: Theme) => css`
  font-size: ${typography.pxToRem(16)};
`;
